// extracted by mini-css-extract-plugin
export default {"cardIndicatorsContainer":"card-widgets_cardIndicatorsContainer__hg4Eq","cardsContainer":"card-widgets_cardsContainer__J-vZL","boxBorder":"card-widgets_boxBorder__6dd+q"};